// extracted by mini-css-extract-plugin
export default {"BreadCrumb":"BreadCrumb_BreadCrumb__SngX-"};